/** Grounded coastal dressing. The beacon piling stands on a route surface;
 * its historical buoy name grants no floating-water or collision behavior. */
export const COASTAL_DETAIL_TEMPLATES = {
  tidal_buoy: { kind: 'lantern_post', name: 'Weathered tide-bell piling', frame: { w: 64, h: 144 }, band: 'architecture' },
  drowned_cobble: { kind: 'moor_stone', name: 'Scattered wet cobbles', frame: { w: 112, h: 36 }, band: 'vegetation',
    supportSurfaces: [{ x: 38, y: 12, width: 36, height: 16 }] },
} as const;
export type CoastalDetailTemplate = keyof typeof COASTAL_DETAIL_TEMPLATES;

export const COASTAL_DETAIL_PALETTES = {
  brine: {
    primary: '#3d4b4d', shade: '#202c30', roof: '#705245', roofEdge: '#84928d',
    wood: '#514b3f', woodEdge: '#92856d', stone: '#637474', iron: '#2a3437',
    glass: '#9b8870', glassCore: '#bdb9a3',
  },
  dusk: {
    primary: '#525864', shade: '#2b303e', roof: '#805d49', roofEdge: '#a1a5aa',
    wood: '#615344', woodEdge: '#b49b7b', stone: '#7e858c', iron: '#363948',
    glass: '#aa8f70', glassCore: '#d7c8a9',
  },
} as const;
